// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"265":"1b6b5a2d","333":"1b6b5a2d","735":"1b6b5a2d","845":"1b6b5a2d"}[chunkId] + ".chunk.css";
};